import BaseService from '@src/services/BaseService'

class QuestionnaireAnswersService extends BaseService {
    constructor() {
        super('questionnaire-answers')
    }
}

export default new QuestionnaireAnswersService()
